import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { getAccount } from '@store'
import { AuthCookieService } from '@ziptility/modules'
import { filter, map } from 'rxjs/operators'

export const hasTokenGuard = () => {
  const cookieService = inject(AuthCookieService)
  const router = inject(Router)

  if (!cookieService.token()) {
    router.navigate(['login'])
    return false
  }

  return true
}

export const hasAccountGuard = () => {
  return inject(Store)
    .select(getAccount)
    .pipe(
      filter((account) => !!account),
      map((account) => !!account),
    )
}

export const isSuperAdminGuard = () => {
  return inject(Store)
    .select(getAccount)
    .pipe(
      filter((account) => !!account),
      map((account) => account.isSuperAdmin()),
    )
}

export const canUseOrganizationSettingsGuard = () => {
  return inject(Store)
    .select(getAccount)
    .pipe(
      filter((account) => !!account),
      map((account) => account.canUseOrganizationsSettings()),
    )
}

export const canViewTasksGuard: CanActivateFn = () => {
  return inject(Store)
    .select(getAccount)
    .pipe(
      filter((account) => !!account),
      map((account) => account.canViewTasks()),
    )
}

export const canUseRolesSettingsGuard = () => {
  return inject(Store)
    .select(getAccount)
    .pipe(
      filter((account) => !!account),
      map((account) => account.canUseRolesSettings()),
    )
}
